// export const url = "https://erp.mgreeninnovations.com/api";
export const url = "https://api.thelocaldaily.in/api";
export const IMAGE_URL = "https://api.thelocaldaily.in/api/image/upload-image";
export const IMAGE_BASE_URL = "https://api.thelocaldaily.in/api/image/get-image";
export const IMAGE_FETCH_URL = "https://api.thelocaldaily.in//api/";
